import React, { useState, useEffect } from "react";

// React Bootstrap
import { Form } from "react-bootstrap";

// Material UI
import Button from "@mui/material/Button";
import RadioGroup from "@mui/material/RadioGroup";
import FormLabel from "@mui/material/FormLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import RadioButton from "./RadioButton";

const GGPI = ({ handleChange, values, voltarPagina, proximaPagina, data }) => {
	const ind_1 = 0;
	const ind_2 = 1;

	const [ggpiError, setGGPIError] = useState(false);
	const [TT, setTTError] = useState(false);

	const submitForm = (e) => {
		e.preventDefault();

		setGGPIError(false);
		setTTError(false);

		if (!values[data.questoes[ind_1].pergunta]) {
			setGGPIError(true);
		}

		if (!values[data.questoes[ind_2].pergunta]) {
			setTTError(true);
		}

		if (
			values[data.questoes[ind_1].pergunta] &&
			values[data.questoes[ind_2].pergunta]
		) {
			proximaPagina();
		}
	};

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<Form noValidate onSubmit={submitForm}>
			<h3>{data.dimensao}</h3>

			<Box className="mt-5">
				<FormControl error={ggpiError}>
					<FormLabel className="mb-2">
						{data.questoes[ind_1].pergunta}
					</FormLabel>
					<RadioGroup onChange={handleChange} required>
						<RadioButton
							value={1}
							name={data.questoes[ind_1].pergunta}
							label={data.questoes[ind_1].alternativas[0]}
							checked={
								values[data.questoes[ind_1].pergunta] === 1
							}
						/>
						<RadioButton
							value={2}
							name={data.questoes[ind_1].pergunta}
							label={data.questoes[ind_1].alternativas[1]}
							checked={
								values[data.questoes[ind_1].pergunta] === 2
							}
						/>
						<RadioButton
							value={3}
							name={data.questoes[ind_1].pergunta}
							label={data.questoes[ind_1].alternativas[2]}
							checked={
								values[data.questoes[ind_1].pergunta] === 3
							}
						/>
						<RadioButton
							value={4}
							name={data.questoes[ind_1].pergunta}
							label={data.questoes[ind_1].alternativas[3]}
							checked={
								values[data.questoes[ind_1].pergunta] === 4
							}
						/>
						<RadioButton
							value={5}
							name={data.questoes[ind_1].pergunta}
							label={data.questoes[ind_1].alternativas[4]}
							checked={
								values[data.questoes[ind_1].pergunta] === 5
							}
						/>
					</RadioGroup>

					{ggpiError ? (
						<FormHelperText>Selecione uma opção</FormHelperText>
					) : null}
				</FormControl>
			</Box>

			<Box className="mt-5">
				<FormControl error={TT}>
					<FormLabel className="mb-2 d-flex align-items-center">
						{data.questoes[ind_2].pergunta}
						<Tooltip
							disableFocusListener
							enterTouchDelay={0}
							leaveTouchDelay={10000}
							sx={{ typography: "body1" }}
							title={
								<Typography fontSize={18}>
									TT refere-se à disponibilização de
									tecnologia, know how ou outro tipo de
									propriedade intelectual para outras empresas
									ou pessoas externas à sua organização,
									formalizada por meio de documentos
									jurídicos.
								</Typography>
							}
						>
							<IconButton sx={{ border: 0.5, m: 2 }}>
								<QuestionMarkIcon fontSize="small" />
							</IconButton>
						</Tooltip>
					</FormLabel>
					<RadioGroup onChange={handleChange} required>
						<RadioButton
							value={1}
							name={data.questoes[ind_2].pergunta}
							label={data.questoes[ind_2].alternativas[0]}
							checked={
								values[data.questoes[ind_2].pergunta] === 1
							}
						/>
						<RadioButton
							value={2}
							name={data.questoes[ind_2].pergunta}
							label={data.questoes[ind_2].alternativas[1]}
							checked={
								values[data.questoes[ind_2].pergunta] === 2
							}
						/>
						<RadioButton
							value={3}
							name={data.questoes[ind_2].pergunta}
							label={data.questoes[ind_2].alternativas[2]}
							checked={
								values[data.questoes[ind_2].pergunta] === 3
							}
						/>
						<RadioButton
							value={4}
							name={data.questoes[ind_2].pergunta}
							label={data.questoes[ind_2].alternativas[3]}
							checked={
								values[data.questoes[ind_2].pergunta] === 4
							}
						/>
						<RadioButton
							value={5}
							name={data.questoes[ind_2].pergunta}
							label={data.questoes[ind_2].alternativas[4]}
							checked={
								values[data.questoes[ind_2].pergunta] === 5
							}
						/>
					</RadioGroup>

					{TT ? (
						<FormHelperText>Selecione uma opção</FormHelperText>
					) : null}
				</FormControl>
			</Box>

			<div className="d-flex justify-content-center mt-5">
				<Button
					className="col-4"
					color="primary"
					size="lg"
					variant="outlined"
					onClick={voltarPagina}
					startIcon={<ArrowBackIosIcon />}
				>
					Voltar
				</Button>

				<span className="col-1"></span>

				<Button
					className="col-4"
					type="submit"
					color="primary"
					size="lg"
					variant="outlined"
					endIcon={<ArrowForwardIosIcon />}
				>
					Próximo
				</Button>
			</div>
		</Form>
	);
};

export default GGPI;
